import React from "react";
import { Grid, Typography } from "@mui/material";
import HomeImages from "assets/images/homeImage.png";
import { useSelector } from "react-redux";
import { showNotificationDialogEmergencyOrder } from "redux/actions/notificationEmergencyOrderActions";
import { postFileAccess, showErrorMessageByCode } from "services/commonServices";
import { SOMS_API_KEY } from "services/CONSTANTS";
import { useDispatch } from "react-redux";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Link } from "react-router-dom";
import ReactDOM from 'react-dom/client';
import ReasonCodesPopup from "components/Validate/ReasonCodesPopup";
import { Provider } from "react-redux";
import { store as reduxStore, persistor } from "redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { PAGE } from "components/common/CONSTANTS";
import { Link as MuiLink } from "@mui/material";

export const Home = () => {
  const loggedInUser = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const userType = useSelector((state) => {
    return state.user;
  });
  const { accessiblePages } = userType.userType;
  const accessiblePagesKeys = Object.keys(accessiblePages);

  const downloadTemplate = () => {
    const request = {
      apikey: SOMS_API_KEY,
      params: {
        fileName: 'emergencyOrderTemplate.csv',
        reportType: 'template'
      }
    }

    postFileAccess(request).then(response => {
      const url = response.fileURL
      const fileDownloadTag = document.createElement('a')
      fileDownloadTag.href = url
      fileDownloadTag.click();
    }).catch(err => {
      const { errTitle, errContent } = showErrorMessageByCode(err)
      dispatch(
        showNotificationDialogEmergencyOrder(errTitle, errContent, 'Done')
      );
    });
  }
  const handleDownloadAndReadFile = () => {
    const width = 500;
    const height = 300;
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;

    const newWindow = window.open(
      "",
      "_blank",
      `width=${width},height=${height},left=${left},top=${top}`
    );
    if (newWindow) {
      const container = newWindow.document.createElement("div");
      newWindow.document.body.appendChild(container);
      const root = ReactDOM.createRoot(container);
      root.render(
        <Provider store={reduxStore}>
          <PersistGate loading={null} persistor={persistor}>
            <ReasonCodesPopup />
          </PersistGate>
        </Provider>
      );
      newWindow.document.close();
    }
  };
  return (
    <Grid container sx={{ py: 3 }} spacing={2}>
      <Grid item md={7}>
        <Typography variant="h4" component="h1">
          Hi, {loggedInUser.loginResponse.name}
        </Typography>
        <Typography variant="h6" component="h2">
          Welcome to Stock Order Management System
        </Typography>
        <br></br>
        {
          accessiblePagesKeys.length === 1
            && accessiblePagesKeys[0] === PAGE.SITE_CANTEEN.key  ?
            <Grid container spacing={2}>
              <Grid item md={10}>
                <Typography variant="h6">
                  <MuiLink
                    component={Link}
                    underline="hover"
                    color="inherit"
                    to={PAGE.SITE_CANTEEN.url}
                  >
                    Manual Orders
                  </MuiLink>
                </Typography>
                <Typography variant="body2" sx={{ color: "#909090" }}>
                  SOMS enables store colleagues to easily create manual stock orders tailored to your operational
                  needs. Order opportunities are specific to your store and can be placed up to 7 days in advance.
                  To ensure all orders are saved, please click create when you have finished
                </Typography>
              </Grid>
            </Grid> :
            <>
              <Typography variant="body2" sx={{ color: "#909090" }}>
                This homepage serves as the entry point to the Stock Order Service Management user interface. 
                It enables users to view and modify third-party customer orders, as well as initiate, update,
                and view emergency orders, manual orders, and manual purchase orders. To navigate through the
                application and access functionalities such as viewing, amending, or raising various types of
                orders—including emergency, manual, and others—please click on the hamburger menu located at
                the top left corner of the screen.
              </Typography>
              <br></br>
              <Grid container spacing={2}>
                <Grid item md={10}>
                  <Typography variant="h6">
                    Third Party Customer Orders
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#909090" }}>
                    Users may amend or cancel third-party customer orders prior to 12:00 PM. Additionally, users have the capability 
                    to download a lifecycle report detailing the status and progression of third-party customer orders.
                  </Typography>
                </Grid>
              </Grid>
              <br></br>
              <Grid container spacing={2}>
                <Grid item md={10}>
                  <Typography variant="h6">
                    Emergency Orders
                    <FileDownloadOutlinedIcon onClick={downloadTemplate} style={{ height: '18px', marginBottom: '-5px', marginRight: '-9px', marginLeft: '4px', color: "#108810", cursor: "pointer" }} />
                    <span> <Link style={{ color: "#108810", cursor: "pointer", fontSize: '0.9rem' }} onClick={downloadTemplate}>Download Template</Link></span>
                    <Link style={{ color: "#108810", cursor: "pointer", fontSize: '0.9rem', marginLeft: '10px' }} onClick={handleDownloadAndReadFile} >View Reasons</Link>
                  </Typography>

                  <Typography variant="body2" sx={{ color: "#909090" }}>
                    Users are permitted to upload emergency orders for any location, including core stores and third-party sites, at any time, 
                    in response to business requirements or unforeseen emergencies. Additionally, users can download the lifecycle report for 
                    emergency orders to track their status and progression.
                  </Typography>
                </Grid>
              </Grid>
              <br></br>
              <Grid container spacing={2}>
                <Grid item md={10}>
                  <Typography variant="h6">
                    Manual Orders
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#909090" }}>
                    Users can upload or create manual orders for any location, including core stores and third-party sites, 
                    in accordance with planned operational requirements. These orders are processed based on the store opportunity 
                    set defined for each item and location. Additionally, users can download the lifecycle report for manual orders 
                    to monitor their status and progression.
                  </Typography>
                </Grid>
              </Grid>
              <br></br>
              <Grid container spacing={2}>
                <Grid item md={10}>
                  <Typography variant="h6">
                    Manual Purchase Orders
                  </Typography>
                  <Typography variant="body2" sx={{ color: "#909090" }}>
                    Users can upload or create manual purchase orders originating from supplier site IDs and directed to depots, 
                    in alignment with planned procurement activities. These orders are processed based on the supplier opportunity 
                    set defined for each item and location. Users can also download the lifecycle report for manual purchase orders 
                    to monitor their status and progression.
                  </Typography>
                </Grid>
              </Grid>
            </>
        }
      </Grid>
      <Grid item md={5}>
        <img src={HomeImages} alt="homeImage"></img>
      </Grid>
    </Grid>
  );
};
